import { readAuthToken, clearAuthToken } from './authToken'

const API_BASE_URL = import.meta.env.VITE_API_URL || 'https://api.dev.vammo.com/v1'

function buildUrl(baseUrl, endpoint = '') {
  const normalizedBase = baseUrl.replace(/\/$/, '')
  const normalizedEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`

  if (!endpoint) return normalizedBase
  return `${normalizedBase}${normalizedEndpoint}`
}

export async function apiRequest(endpoint, options = {}) {
  const { handleAuthErrorManually, requireAuth = true, timeout = 180000, ...fetchOptions } = options
  const token = readAuthToken()

  if (requireAuth && !token) {
    throw new Error('Missing auth token')
  }

  const headers = {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    ...fetchOptions.headers,
  }

  if (requireAuth && token) {
    headers.Authorization = `Bearer ${token}`
  }

  // Set up timeout controller
  const controller = new AbortController()
  const timeoutId = setTimeout(() => controller.abort(), timeout)

  try {
    const response = await fetch(buildUrl(API_BASE_URL, endpoint), {
      ...fetchOptions,
      headers,
      signal: controller.signal,
    })
    
    clearTimeout(timeoutId)

  if (!response.ok) {
    if (response.status === 401 && !handleAuthErrorManually) {
      clearAuthToken()
    }

    throw new Error(`HTTP error! status: ${response.status}`)
  }

  const contentType = response.headers.get('content-type') || ''
  if (contentType.includes('application/json')) {
    return response.json()
  }

  return response.text()
  } catch (error) {
    if (error.name === 'AbortError') {
      throw new Error('HTTP error! status: 408')
    }
    throw error
  }
}
